/**
 * ModalFooter
 *
 * Renders a footer bar for a modal.  Only use as a child of Modal.
 * See modal.jsx for more details.
 */

import {css, StyleSheet} from "aphrodite";
import * as React from "react";

export class ModalFooter extends React.Component<{
    children?: React.ReactNode;
    style?: {
        backgroundColor?: string;
        justifyContent?: string;
        paddingLeft?: number;
        paddingRight?: number;
        paddingInlineStart?: number;
        paddingInlineEnd?: number;
    };
}> {
    render(): React.ReactNode {
        const {children, style} = this.props;

        return (
            <div className={css(styles.footer)} style={style}>
                {children}
            </div>
        );
    }
}

// TODO(kevinb): dedupe with styles in modal-header.jsx
const headerHeight = 60;

const styles = StyleSheet.create({
    footer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        boxShadow: "0 -1px 0 0 rgba(0, 0, 0, 0.15)",
        flexGrow: 0,
        flexShrink: 0,
        position: "relative",
        height: headerHeight,
    },
});

export default ModalFooter;
